import React from 'react'
import { LdsDualRingSpinnerDefault, LoadingOverlay } from '../styles/styled-elements'

const LoadingScreen = ({show}) => (<LoadingOverlay show={show}>
  <LdsDualRingSpinnerDefault />
</LoadingOverlay>)

export default LoadingScreen
